import Peeker from "../../services/peeker";

export default function (peeker: Peeker) {
  return {
    state: {
      peeker: peeker,
    },
    mutations: {
      peek(state, peekerOptions: object = {}) {
        state.peeker.peek(peekerOptions);
      },
    },
  };
}
